import React from 'react'

const Footer = () => {
  return (
    <footer className='bg-primary-darker py-[24px] text-white text-sm text-center'>
      2025 &copy; ATA Law Partners &amp; Associates. All rights reserved.
    </footer>
  )
}

export default Footer
